"use client"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="ar" dir="rtl">
      <body
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0f172a",
          color: "white",
          fontFamily: "system-ui, sans-serif",
          padding: "1rem",
        }}
      >
        <div
          style={{
            maxWidth: "500px",
            textAlign: "center",
            padding: "2rem",
            backgroundColor: "#1e293b",
            borderRadius: "0.5rem",
            border: "1px solid #ef4444",
          }}
        >
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "#ef4444" }}>⚠️ حدث خطأ خطير</h2>
          <p style={{ marginBottom: "1rem", color: "#cbd5e1" }}>{error.message || "حدث خطأ غير متوقع في التطبيق"}</p>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "0.375rem",
              cursor: "pointer",
              fontSize: "1rem",
              marginBottom: "0.5rem",
              width: "100%",
            }}
          >
            إعادة المحاولة
          </button>
          <button
            onClick={() => (window.location.href = "/")}
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "transparent",
              color: "#cbd5e1",
              border: "1px solid #475569",
              borderRadius: "0.375rem",
              cursor: "pointer",
              fontSize: "1rem",
              width: "100%",
            }}
          >
            العودة للصفحة الرئيسية
          </button>
        </div>
      </body>
    </html>
  )
}
